import React, { useState } from 'react';
import { withAppContext } from '@ctsu/loader';
import bindLogger from 'helpers/BindLogger';
import { getPatientAutoCompleteApi } from 'actions/packet';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import TypeAhead from './TypeAhead';

function PatientTypeAhead({ context, onChange, value }) {
  const [patientAutocompleteOptions, setPatientAutocompleteOptions] = useState();
  const dispatch = useDispatch();
  const action = bindActionCreators({ getPatientAutoCompleteApi }, dispatch);
  const fetchOptions = (searchText) => {
    if (searchText == null || searchText.trim().length < 3) {
      setPatientAutocompleteOptions([]);
      return;
    }
    // if the input is not empty
    bindLogger(
      action.getPatientAutoCompleteApi,
      context
    )(searchText.toUpperCase()).subscribe((resp) => {
      const { response } = resp;
      if (response) {
        setPatientAutocompleteOptions(
          response.map((siteObj) => ({
            label: `${siteObj.patientId} | ${siteObj.protocolNumber}`,
            value: siteObj.patientId,
            protocolNumber: siteObj.protocolNumber
          }))
        );
      }
    });
  };

  return (
    <TypeAhead
      name="Person"
      value={value}
      options={patientAutocompleteOptions}
      onChange={onChange}
      onChangeText={fetchOptions}
    />
  );
}

export default withAppContext(PatientTypeAhead);
